
import mobileNav from './modules/mobile-nav.js';
import stickyHeader from './modules/sticky-header.js';
import portfolioFilter from './modules/portfolio-filter.js';
import blogFilter from './modules/blog-filter.js';
import contactPopup from "./modules/contact-popup.js";
import slider from './modules/slider.js';
import serviceLinks from './modules/service-links.js';
import phoneTracking from './modules/phone-tracking.js';
import articleEnhancements from './modules/article-enhancements.js';
import wrapTables from './modules/wrap-tables.js';
import visitDuration from './modules/visit-duration.js';


mobileNav();
stickyHeader(400);
portfolioFilter();
blogFilter();
contactPopup();
slider();
serviceLinks();
phoneTracking();
articleEnhancements();
wrapTables('.main-content table, .article__body table');
visitDuration();
